import React from 'react';

const FormProgress = ({ formStructure, formData, onSectionClick, visibleFieldIds }) => {
  if (!formStructure || !formStructure.sections) return null;

  const getVisibleFields = (fields) => {
    if (!visibleFieldIds) return fields;
    return fields.filter(f => visibleFieldIds.has(f.id));
  };

  const totalFields = formStructure.sections.reduce((sum, section) => sum + getVisibleFields(section.fields).length, 0);
  const filledFields = formStructure.sections.reduce((sum, section) => {
    return sum + getVisibleFields(section.fields).filter(field => {
      const value = formData[field.id];
      return value && value.toString().trim() !== '';
    }).length;
  }, 0);
  const overallProgress = totalFields > 0 ? Math.round((filledFields / totalFields) * 100) : 0;

  return (
    <div style={{
      backgroundColor: 'white',
      border: '1px solid #e5e7eb',
      borderRadius: '0.75rem',
      padding: '1.5rem',
      marginBottom: '1.5rem'
    }}>
      <div style={{ marginBottom: '1rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
          <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#111827', margin: 0 }}>
            Formular Fortschritt
          </h3>
          <span style={{
            fontSize: '0.875rem',
            color: overallProgress === 100 ? '#059669' : '#6b7280',
            fontWeight: '600'
          }}>
            {overallProgress}%
          </span>
        </div>

        <div style={{
          backgroundColor: '#e5e7eb',
          borderRadius: '9999px',
          height: '0.5rem',
          overflow: 'hidden'
        }}>
          <div
            style={{
              backgroundColor: overallProgress === 100 ? '#10b981' : '#2563eb',
              height: '100%',
              borderRadius: '9999px',
              transition: 'width 0.3s',
              width: `${overallProgress}%`
            }}
          />
        </div>
      </div>

      <div style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '1rem' }}>
        {filledFields} of {totalFields} fields completed
      </div>

      {/* Section Progress */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {formStructure.sections.map((section) => {
          const sectionVisible = getVisibleFields(section.fields);
          if (sectionVisible.length === 0) return null;

          const sectionFilledFields = sectionVisible.filter(field => {
            const value = formData[field.id];
            return value && value.toString().trim() !== '';
          }).length;

          const sectionProgress = sectionVisible.length > 0
            ? Math.round((sectionFilledFields / sectionVisible.length) * 100)
            : 0;

          return (
            <div
              key={section.sectionId}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0.5rem',
                borderRadius: '0.375rem',
                cursor: onSectionClick ? 'pointer' : 'default',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => {
                if (onSectionClick) e.currentTarget.style.backgroundColor = '#f3f4f6';
              }}
              onMouseOut={(e) => {
                if (onSectionClick) e.currentTarget.style.backgroundColor = 'transparent';
              }}
              onClick={() => onSectionClick && onSectionClick(section.sectionId)}
            >
              <span style={{ fontSize: '0.875rem', color: '#374151' }}>
                {section.title}
              </span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <div style={{
                  width: '3rem',
                  backgroundColor: '#e5e7eb',
                  borderRadius: '9999px',
                  height: '0.25rem',
                  overflow: 'hidden'
                }}>
                  <div
                    style={{
                      backgroundColor: sectionProgress === 100 ? '#10b981' : '#2563eb',
                      height: '100%',
                      borderRadius: '9999px',
                      width: `${sectionProgress}%`
                    }}
                  />
                </div>
                <span style={{
                  fontSize: '0.75rem',
                  color: sectionProgress === 100 ? '#059669' : '#6b7280',
                  minWidth: '2.5rem',
                  textAlign: 'right'
                }}>
                  {sectionFilledFields}/{sectionVisible.length}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FormProgress;
